<template>
  <div class="events-list-wrap">
    <div class="top-head">
      <div class="container">
        <div class="list-wrap">
          <div class="back-to-profile-text-event">
            <div class="d-flex width-100-p place-items-center" @click="handleBackClick" v-if="!isOwner">
              <a-icon type="arrow-left" />
              <span class="margin-l-1">Back to profile</span>
            </div>
          </div>
          <div class="back">
            <span class="pointer-hover" @click="toggleFormShow" v-if="isForm">
              <a-icon type="arrow-left" />Back to Events List
            </span>
          </div>
          <div class="event-types" v-if="isEditable">
            <div class="type" @click="changeEvents('new')">Upcoming Events</div>
            <div class="type" @click="changeEvents('past')">Past Events</div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="events-content-wrap">
        <div class="head">
          <div class="head-title">
            <div class="name">{{ athlete.athleteName }}</div>
            <h2 class="form-title">{{ pageTitle }}</h2>
          </div>
          <div class="add-event">
            <a-button
              type="primary"
              class="add-event-btn"
              icon="plus"
              @click="saveForm"
              v-if="isEditable && !isForm && pageTitle === 'Upcoming Events'"
              >Add New Event</a-button
            >
          </div>
        </div>
        <div class="events-wrap" v-if="!isForm">
          <a-list
            :grid="{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4 }"
            :dataSource="athleteListEvents"
            :pagination="pagination"
            :loading="athleteEventsLoading"
          >
            <a-list-item
              slot="renderItem"
              slot-scope="item"
              class="event-detail"
            >
              <EventCard
                :event="item"
                @on-change="editForm"
                @after-delete="getUpcoming"
                :viewOnly="viewOnly"
              />
            </a-list-item>
          </a-list>
        </div>
        <div class="form-wrap" v-else>
          <div class="form-content">
            <div class="heading">
              <h2
                class="form-title event-form-title"
                v-if="formType === 'save'"
              >
                Add New Event
              </h2>
              <h2 class="form-title" v-else>Edit Event</h2>
            </div>
            <a-form layout="horizontal" :form="form" @submit="handleSubmit">
              <div class="image-info">
                <BaseDragUpload
                  class="drag-image-wrapper"
                  @file-upload="image => handleImageUpload(image)"
                  :imageUrl="imageUrl"
                />
              </div>
              <div class="event-basic-info">
                <a-form-item label="Title">
                  <a-input
                    ref="title"
                    v-decorator="[
                      'title',
                      {
                        rules: [
                          {
                            required: true,
                            message: 'Please enter title of the Event!'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
                <a-form-item label="Description">
                  <a-textarea
                    ref="description"
                    :auto-size="{ minRows: 8, maxRows: 8 }"
                    v-decorator="[
                      'description',
                      {
                        rules: [
                          {
                            required: false,
                            message: 'Please enter description of the Event!'
                          }
                        ]
                      }
                    ]"
                  />
                </a-form-item>
              </div>
              <div class="event-type-info">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <a-form-item label="Event Type">
                      <a-select
                        ref="eventType"
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        @change="handleEventChange"
                        v-decorator="[
                          'eventType',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Event Type!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select Event Type"
                      >
                        <a-select-option
                          v-for="event in eventInfo.eventTypeList"
                          :key="event._id"
                          :value="event._id"
                          >{{ event.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team A">
                      <a-input
                        ref="teamA"
                        v-decorator="[
                          'teamA',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Team A!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12" v-if="currentEventType === 'Game Schedule'">
                    <a-form-item label="Team B">
                      <a-input
                        ref="teamB"
                        v-decorator="[
                          'teamB',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please select Team B!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="date-time-info">
                <a-row :gutter="24">
                  <a-col :sm="8">
                    <a-form-item label="Date">
                      <a-date-picker
                        ref="date"
                        :style="{ width: '100%' }"
                        :disabled-date="disabledDate"
                        v-decorator="[
                          'date',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Date!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item label="Time">
                      <a-time-picker
                        ref="time"
                        :style="{ width: '100%' }"
                        use12-hours
                        format="h:mm a"
                        v-decorator="[
                          'time',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Time!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="8">
                    <a-form-item label="Age Group">
                      <a-select
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'age',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Age Group!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select Age Group"
                      >
                        <a-select-option
                          ref="age"
                          v-for="age in eventInfo.ageGroupList"
                          :key="age._id"
                          :value="age._id"
                          >{{ age.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>
              <div class="location-info">
                <a-row :gutter="24">
                  <a-col :sm="12">
                    <a-form-item label="City">
                      <a-input
                        ref="city"
                        v-decorator="[
                          'city',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter City!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12">
                    <a-form-item label="State">
                      <a-select
                        show-search
                        ref="state"
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'state',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select State!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select State"
                      >
                        <a-select-option
                          v-for="state in eventInfo.stateList"
                          :key="state._id"
                          :value="state._id"
                          >{{ state.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Address">
                      <a-input
                        ref="location"
                        v-decorator="[
                          'location',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please enter Location!'
                              }
                            ]
                          }
                        ]"
                      />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="24">
                    <a-form-item label="Google Location">
                      <a-input v-decorator="['googleLocation']" />
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12">
                    <a-form-item label="Field">
                      <a-select
                        ref="field"
                        show-search
                        option-filter-prop="children"
                        :filter-option="filterOption"
                        v-decorator="[
                          'field',
                          {
                            rules: [
                              {
                                required: true,
                                message: 'Please Select Field!'
                              }
                            ]
                          }
                        ]"
                        placeholder="Select Field"
                      >
                        <a-select-option
                          v-for="(field, index) in eventInfo.fieldList"
                          :key="index"
                          :value="field"
                          >{{ field }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                  <a-col :sm="12">
                    <a-form-item label="Sponsor">
                      <a-input v-decorator="['sponsor']" />
                    </a-form-item>
                  </a-col>
                </a-row>
              </div>

              <a-form-item>
                <div class="button-wrapper d-flex-spc-btwn">
                  <span>
                    <a-button
                      type="primary"
                      html-type="submit"
                      class="next-button save-button"
                      >Save</a-button
                    >
                  </span>
                  <span>
                    <a-button
                      type="primary"
                      class="next-button"
                      @click="cancelForm"
                      >Cancel</a-button
                    >
                  </span>
                </div>
              </a-form-item>
            </a-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import EventCard from "./card";
import isEmpty from "@/utils/isEmpty";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { Base } from "@/models";
import { Athlete } from "@/models";

const ATHLETE_STORE_KEY = "athleteStore";
const ATHLETE_EVENT_STORE_KEY = "athleteEventStore";
const taxonomyRepository = RepositoryFactory.get("taxonomy");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "AthleteEventList",
  components: {
    EventCard
  },
  data() {
    return {
      isForm: false,
      imageSrc: "",
      imageUrl: "",
      formType: "save",
      toEditId: "",
      currentEventType: "",
      viewOnly: false,
      pageTitle: "Upcoming Events",
      taxonomyvalues: [
        {
          name: "stateList",
          taxValue: "College State"
        },
        {
          name: "ageGroupList",
          taxValue: "Age Group"
        },
        {
          name: "eventTypeList",
          taxValue: "Player Event Type"
        }
      ],
      eventInfo: {
        stateList: [],
        eventTypeList: [],
        ageGroupList: [],
        fieldList: [
          "Field 1",
          "Field 2",
          "Field 3",
          "Field 4",
          "Field 5",
          "Field 6",
          "Field 7",
          "Field 8",
          "Field 9",
          "Field 10",
          "Field 11",
          "Field 12"
        ]
      },
      currentPage: 1,
      hasErrors,
      form: this.$form.createForm(this),
      pagination: {
        pageSize: 12,
        simple: true
      }
    };
  },
  mounted() {
    this.getUpcoming();
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      this.form.validateFields();
    });
  },
  created() {
    for (let i = 0; i < this.taxonomyvalues.length; i++) {
      taxonomyRepository
        .getSortedTaxonomyValues(this.taxonomyvalues[i].taxValue)
        .then(response => {
          this.eventInfo[this.taxonomyvalues[i].name] =
            response.data.taxonomy.values;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  computed: {
    athleteId() {
      return this.$route.params.id || Athlete.profileId();
    },
    isOwner() {
      return this.athleteId === localStorage["profile-id"];
    },
    ...mapGetters({
      athleteListEvents: `${ATHLETE_EVENT_STORE_KEY}/athleteListEvents`,
      athleteEventsLoading: `${ATHLETE_EVENT_STORE_KEY}/athleteEventsLoading`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`
    }),
    isEditable() {
      return this.profileId === localStorage["profile-id"];
    },
    playerId() {
      return this.profileId || localStorage["player-id"];
    },
    profileId() {
      return this.$route.params.id || Base.profileId();
    },
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    }
  },
  methods: {
    handleBackClick() {
      this.$router.push(
        `/${this.$route.params.profileId}/athlete/${this.$route.params.id}/summary`
      );
    },
    getUpcoming(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${ATHLETE_EVENT_STORE_KEY}/getAthleteEventsList`, {
        page,
        "date[gte]": this.currentDate,
        sort: "date",
        profileId: this.profileId
      });
      this.viewOnly = false;
      this.pageTitle = "Upcoming Events";
      this.imageUrl = "";
    },
    getPast(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${ATHLETE_EVENT_STORE_KEY}/getAthleteEventsList`, {
        page,
        sort: "date",
        "date[lte]": this.currentDate,
        profileId: this.profileId
      });
      this.viewOnly = true;
      this.pageTitle = "Past Events";
      this.imageUrl = "";
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },
    getHidden(page = 1) {
      this.currentPage = page;
      this.$store.dispatch(`${ATHLETE_EVENT_STORE_KEY}/getAthleteEventsList`, {
        page,
        sort: "date",
        profileId: this.playerId
      });
      this.viewOnly = false;
      this.pageTitle = "Hidden Events";
      this.imageUrl = "";
    },

    toggleFormShow() {
      this.isForm = !this.isForm;
    },

    handleSubmit(e) {
      e.preventDefault();

      this.form.validateFields((err, values) => {
        if (err) {
          this.$refs[Object.keys(err)[0]].focus();
        }
        if (!err) {
          let toSend = {
            title: values.title,
            description: values.description,
            date: new Date(values.date).toLocaleDateString(),
            time: values.time.format("hh:mm A"),
            state: values.state,
            age: values.age,
            city: values.city,
            location: values.location,
            field: values.field,
            googleLocation: values.googleLocation ? values.googleLocation : "",
            sponsor: values.sponsor,
            eventType: values.eventType,
            teamA: values.teamA ? values.teamA : "",
            teamB: values.teamB ? values.teamB : ""
          };
          if (this.formType === "save") {
            toSend.profileId = this.profileId;
            toSend.athleteName = "Milo Thap";
            this.saveEvent(toSend);
          } else {
            this.editEvent(toSend);
          }
        }
      });
    },

    async saveEvent(toSend) {
      await this.$store.dispatch(
        `${ATHLETE_EVENT_STORE_KEY}/createAthleteEventsList`,
        {
          toSend
        }
      );
      let formData = new FormData();
      formData.append("file", this.imageSrc);
      if (this.imageSrc)
        await this.$store.dispatch(
          `${ATHLETE_EVENT_STORE_KEY}/updateImageForEvent`,
          {
            id: this.athleteListEvents[0].id,
            image: formData
          }
        );
      this.getUpcoming();
      this.isForm = !this.isForm;
    },

    async editEvent(toSend) {
      await this.$store.dispatch(
        `${ATHLETE_EVENT_STORE_KEY}/updateAthleteEventsList`,
        {
          toSend,
          id: this.toEditId
        }
      );
      let formData = new FormData();
      formData.append("file", this.imageSrc);
      if (
        this.imageSrc !==
        this.athleteListEvents.find(event => event.id === this.toEditId)[
          "image"
        ]
      )
        await this.$store.dispatch(
          `${ATHLETE_EVENT_STORE_KEY}/updateImageForEvent`,
          {
            id: this.toEditId,
            image: formData
          }
        );
      this.getUpcoming();
      this.isForm = !this.isForm;
    },

    changeEvents(val) {
      if (val === "new") {
        this.getUpcoming();
      } else if (val === "past") {
        this.getPast();
      } else if (val === "hidden") {
        this.getHidden();
      }
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
    },

    handleEventChange(value) {
      let type = this.eventInfo.eventTypeList.filter(
        type => type._id === value
      );
      this.currentEventType = type[0].name;
    },

    saveForm() {
      this.isForm = !this.isForm;
      this.formType = "save";
    },
    cancelForm() {
      this.isForm = false;
      this.formType = "save";
      this.currentEventType = "";
      this.toEditId = "";
      this.imageUrl = "";
    },
    editForm(value) {
      this.isForm = true;
      this.imageUrl = value.image;
      this.formType = "edit";
      this.toEditId = value.id;
      this.imageSrc = value.image;
      let d = new Date(value.date);
      let that = this;
      if (value.eventType.name === "Game Schedule") {
        this.currentEventType = "Game Schedule";
      }
      setTimeout(function() {
        that.form.setFieldsValue({
          title: value.title,
          description: value.description,
          state: value.state
            ? value.state._id
              ? value.state._id
              : value.state
            : "",
          age: value.age ? (value.age._id ? value.age._id : value.age) : "",
          city: value.city,
          field: value.field,
          date: moment(d).format("YYYY-MM-DD"),
          time: moment(value.time, "hh:mm A"),
          location: value.location,
          googleLocation: value.googleLocation,
          sponsor: value.sponsor,
          eventType: value.eventType
            ? value.eventType._id
              ? value.eventType._id
              : value.eventType
            : "",
          teamA: value.teamA ? value.teamA : "",
          teamB: value.teamB ? value.teamB : ""
        });
      }, 1000);
    },
    handleImageUpload(image) {
      this.imageSrc = image;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    }
  }
};
</script>
